import { render, staticRenderFns } from "./ChildInsurance.vue?vue&type=template&id=fcab11ce&"
import script from "./ChildInsurance.vue?vue&type=script&lang=js&"
export * from "./ChildInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports